class CreateurModel {
    constructor(data = {}) {
        this.id = data.id || null;
        this.email = data.email || null; // non modifiable
        // ✅ nouveau
        this.photo_background = data.photo_background || null;

        // ✅ bio
        this.bio = data.bio || "";

        // ✅ réseaux sociaux
        this.instagram_url = data.instagram_url || "";
        this.facebook_url = data.facebook_url || "";
        this.linkedin_url = data.linkedin_url || "";
        this.youtube_url = data.youtube_url || "";
        // Infos principales
        this.nomComplet = data.nomComplet || null;
        this.telephone = data.telephone || null;
        this.photo_profil =
            data.photo_profil ||
            "https://cdn.loeildelaphotographie.com/wp-content/uploads/2013/02/original_1-facebook-profile-picture-jpg-500x350.jpg";

        // Entreprise / créateur
        this.siret = data.siret || null;
        this.raison_sociale = data.raison_sociale || null;
        this.code_postal_siege = data.code_postal_siege || null;
        this.rue_siege = data.rue_siege || null;
        this.ville_siege = data.ville_siege || null;
        this.dirigeant_siege = data.dirigeant_siege || null;

        // Relations
        this.parent_id = data.parent_id || null;

        // Rôle
        this.role = data.role || "createur";

        // Notes
        this.note1 = data.note1 || 0;
        this.note2 = data.note2 || 0;
        this.note3 = data.note3 || 0;
        this.note4 = data.note4 || 0;
        this.note5 = data.note5 || 0;

        // Note moyenne calculée côté backend
        this.note_moyenne = data.note_moyenne || 0;

        // Métadonnées
        this.created_at = data.created_at || null;
        this.updated_at = data.updated_at || null;
    }
}

export default CreateurModel;
